import React from "react";
import './radio.css'
import { color } from "../../utils/themes/color";
import { Radio } from "antd";

export default function RADIO(props) {

 
    return (
        <Radio.Group
            onChange={(e) => props.click(e.target.value)}
            defaultValue={props.defaultValue != null ? props.defaultValue : null}
            
        >

            {
                props.items != null && props.items.lenght != 0 ?
                    props.items.map((itm, idx) => {
                        return <Radio key={idx} value={itm.value}>{itm.name}</Radio>

                    })
                    : null
            }

        </Radio.Group>
    )


}

